import React, { memo, useEffect } from 'react';
import { truncateString } from '@helpers/stringHelpers';
import { NewsItem } from '@pages/NewsList/NewsList.types';

interface NewsListItemVerticalProps {
  model: NewsItem;
}

export const NewsListItemVertical = memo(({ model }: NewsListItemVerticalProps) => {
  return (
    <a href={model.ContentLink} className='c-news-block'>
      <div className='c-news-block-container'>
        <div className='c-news-block-thumbnail hide-in-desktop'>
          <img
            loading='lazy'
            src={model.Image}
            alt={model.ImageAlt}
            className='c-news-block-list-image'
            height='360'
            width='640'
          />
        </div>
        <div className='c-news-block-content'>
          <span className='c-news-block-date-text'>{model.Date}</span>
          <h4 className='c-news-block-title-text'>{model.Title}</h4>
          <p className='c-news-block-content-text'>{truncateString(model.Introduction, 100)}</p>
        </div>
      </div>
    </a>
  );
});
